import gql from 'graphql-tag'

const allInteressi = gql`
  query allInteressi {
    allInteressi {
      nome
    }
  }
`

export default allInteressi



// WEBPACK FOOTER //
// ./src/graphql/queries/interessi.js